module.exports = __webpack_public_path__ + "img/sleep_bg.2dc59f0e.png";